import { TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { unstable_useEnhancedEffect as useEnhancedEffect } from "@mui/utils";
import {
  GridColDef,
  GridRenderCellParams,
  useGridApiContext,
} from "@mui/x-data-grid";
import { TimePicker } from "@mui/x-date-pickers";
import { useEffect, useRef } from "react";

function TimePickerEditInputCell(props: GridRenderCellParams<any, any>) {
  const { id, value, field, hasFocus } = props;
  const apiRef = useGridApiContext();
  const ref = useRef<any>(null);

  const handleChange = (date: Date | null) => {
    if (date) {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const hour = `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;
      console.log("🚀 ~ newValue:", hour);
      apiRef.current.setEditCellValue({ id, field, value: hour });
    } else {
      console.log("Invalid date received.");
      apiRef.current.setEditCellValue({ id, field, value: "" });
    }
  };

  useEnhancedEffect(() => {
    if (hasFocus && ref.current) {
      const input = ref.current.querySelector("input");
      input?.focus();
    }
  }, [hasFocus, value]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", pr: 2 }}>
      <TimePicker
        value={value}
        onChange={handleChange}
        inputRef={ref} // استفاده از inputRef به جای ref مستقیم
      />
    </Box>
  );
}

export const renderRatingEditInputCell: GridColDef["renderCell"] = (params) => {
  return <TimePickerEditInputCell {...params} />;
};

export function renderTime(params: GridRenderCellParams<any, number>) {
  return params.value;
}
